const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * 1024;
export function formatFileSize(bytes) {
    if (bytes === undefined || !Number.isFinite(bytes) || bytes <= 0)
        return null;
    if (bytes < BYTES_PER_KB)
        return `${bytes} B`;
    if (bytes < BYTES_PER_MB)
        return `${Math.round(bytes / BYTES_PER_KB)} KB`;
    return `${(bytes / BYTES_PER_MB).toFixed(1)} MB`;
}
export function isImageAttachment(attachment) {
    var _a, _b;
    return (_a = attachment.isImage) !== null && _a !== void 0 ? _a : ((_b = attachment.mimeType) !== null && _b !== void 0 ? _b : '').toLowerCase().startsWith('image/');
}
/** What the modal shows for this file: a picture, an embedded pdf, or a file card. */
export function attachmentKind(attachment) {
    var _a;
    if (isImageAttachment(attachment))
        return 'image';
    const isPdf = ((_a = attachment.mimeType) !== null && _a !== void 0 ? _a : '').toLowerCase() === 'application/pdf' || /\.pdf$/i.test(attachment.name);
    return isPdf ? 'pdf' : 'file';
}
// Ordered: the first matching rule wins. Matched on content type, then on the file extension
// (agents attach files whose browsers report a generic octet-stream type).
const ICON_RULES = [
    { icon: 'fa-light fa-file-pdf', label: 'PDF document', mime: /pdf/, ext: /\.pdf$/ },
    {
        icon: 'fa-light fa-file-word',
        label: 'Word document',
        mime: /word|wordprocessingml|msword/,
        ext: /\.(docx?|rtf)$/
    },
    { icon: 'fa-light fa-file-excel', label: 'Spreadsheet', mime: /excel|spreadsheetml|csv/, ext: /\.(xlsx?|csv)$/ },
    { icon: 'fa-light fa-file-zipper', label: 'Archive', mime: /zip|compressed|tar|rar/, ext: /\.(zip|rar|7z|tar|gz)$/ },
    { icon: 'fa-light fa-file-lines', label: 'Text file', mime: /^text\//, ext: /\.(txt|log|md)$/ },
    { icon: 'fa-light fa-file-image', label: 'Image', mime: /^image\//, ext: /\.(png|jpe?g|gif|webp|heic)$/ },
    { icon: 'fa-light fa-file-audio', label: 'Audio', mime: /^audio\//, ext: /\.(mp3|wav|m4a)$/ },
    { icon: 'fa-light fa-file-video', label: 'Video', mime: /^video\//, ext: /\.(mp4|mov)$/ }
];
const DEFAULT_LABEL = 'File';
const DEFAULT_ICON = 'fa-light fa-file';
function matchingRule(attachment) {
    var _a;
    const mime = ((_a = attachment.mimeType) !== null && _a !== void 0 ? _a : '').toLowerCase();
    const name = attachment.name.toLowerCase();
    return ICON_RULES.find((rule) => rule.mime.test(mime) || rule.ext.test(name));
}
export function attachmentIconClass(attachment) {
    var _a, _b;
    return (_b = (_a = matchingRule(attachment)) === null || _a === void 0 ? void 0 : _a.icon) !== null && _b !== void 0 ? _b : DEFAULT_ICON;
}
/** "PDF document · 340 KB": the details line of the file card. */
export function attachmentDetails(attachment) {
    var _a, _b;
    return [(_b = (_a = matchingRule(attachment)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : DEFAULT_LABEL, formatFileSize(attachment.sizeBytes)]
        .filter(Boolean)
        .join(' · ');
}
